import type { Ref } from "vue";
import type { AddressSelectionState } from "../types";

/** 住所選択ダイアログの戻る遷移に必要な依存を表す型。 */
type UseAddressDialogNavigationParams = {
  state: AddressSelectionState;
  btnNonMemberToggle: Ref<number>;
  originalCityAddress: Ref<string>;
  originalSectionAddress: Ref<string>;
  unassignedBlockList: Ref<Array<string | null | undefined>>;
  syncCoreFromRefs: () => void;
  syncRefsFromCore: () => void;
  setDialog: (addressDialog: boolean, areaDialog: boolean) => void;
  areaClear: () => void | Promise<void>;
  onBackToAddressDialog?: () => void | Promise<void>;
};

/** 住所ダイアログとエリアダイアログの共通遷移を扱う composable。 */
export const useAddressDialogNavigation = (params: UseAddressDialogNavigationParams) => {
  const {
    state,
    btnNonMemberToggle,
    originalCityAddress,
    originalSectionAddress,
    unassignedBlockList,
    syncCoreFromRefs,
    syncRefsFromCore,
    setDialog,
    areaClear,
    onBackToAddressDialog,
  } = params;

  const backToAddressDialog = async (): Promise<void> => {
    await areaClear();
    if (onBackToAddressDialog) {
      await onBackToAddressDialog();
    }
    setDialog(true, false);
    syncRefsFromCore();
  };

  /** 住所ダイアログを閉じる。 */
  const onCloseAddressDialog = async (): Promise<void> => {
    syncCoreFromRefs();
    setDialog(false, false);
    syncRefsFromCore();
  };

  /** エリア選択ダイアログの戻る遷移を処理する。 */
  const onClickAreaDialogReturn = async (): Promise<void> => {
    syncCoreFromRefs();

    if (
      btnNonMemberToggle.value === 0 &&
      state.blockList.length > 0 &&
      state.cityBlockList === null &&
      state.sectionBlockList === null
    ) {
      await backToAddressDialog();
      return;
    }

    if (state.blockList.length > 0) {
      state.blockList = [];
      originalSectionAddress.value = "";
      unassignedBlockList.value = [];
      syncRefsFromCore();
      return;
    }

    if (state.sectionBlockList) {
      if (btnNonMemberToggle.value === 0 && state.cityBlockList === null) {
        await backToAddressDialog();
        return;
      }

      state.sectionBlockList = null;
      state.section = "";
      state.city = "";
      originalCityAddress.value = "";
      originalSectionAddress.value = "";
      syncRefsFromCore();
      return;
    }

    await backToAddressDialog();
  };

  return {
    onCloseAddressDialog,
    onClickAreaDialogReturn,
  };
};
